import React from 'react';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';

interface QuantityInputProps {
	control: any;
	name: string;
	unitValue?: number;
	defaultValue?: number | string;
	placeholder: string;
	isInvalid?: boolean;
}

// A coluna no banco é decimal(20,5): 15 dígitos inteiros; 12 já cobre qualquer quantidade real.
const MAXIMO_DIGITOS_INTEIROS = 12;

export default function QuantityInput({
	control,
	name,
	unitValue,
	defaultValue,
	placeholder,
	isInvalid
}: QuantityInputProps) {
	const isUnits = Number(unitValue) === 3;

	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ value, onChange }) => (
				<NumberFormat
					customInput={Form.Control}
					value={value ?? ''}
					placeholder={placeholder}
					inputMode={isUnits ? 'numeric' : 'decimal'}
					thousandSeparator="."
					decimalSeparator=","
					isAllowed={({ value: numericValue }) =>
						numericValue.split('.')[0].length <= MAXIMO_DIGITOS_INTEIROS
					}
					decimalScale={isUnits ? 0 : 2}
					fixedDecimalScale={!isUnits}
					allowNegative={false}
					isInvalid={isInvalid}
					onValueChange={({ floatValue, value: numericValue }) =>
						onChange(numericValue === '' ? '' : floatValue)
					}
				/>
			)}
		/>
	);
}
